/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * TenantData
 */
export type TenantRecordItem = {
    /**
     * Record Unique ID
     */
    id?: number;
    /**
     * TenantData name
     */
    name?: string;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    created?: number;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    updated?: number;
    /**
     * createdBy Unique ID
     */
    createdBy?: number;
    /**
     * updatedBy Unique ID
     */
    updatedBy?: number;
    /**
     * Flag for record being active
     */
    active?: boolean;
    /**
     * Theme to use for Tenant in the UI
     */
    theme?: TenantRecordItem.theme;
    /**
     * API Response Version
     */
    _ver?: number;
}

export namespace TenantRecordItem {

    /**
     * Theme to use for Tenant in the UI
     */
    export enum theme {
        ONVIV = 'onviv',
        DEFAULT = 'default',
        INSIGHT = 'insight',
        CEN = 'cen',
        WALDRON = 'waldron',
        MDOPINIONS = 'mdopinions',
    }


}
